import React from 'react';
import type { SearchQuery } from '../types';
import { useLocalization } from '../hooks/useLocalization';

interface ResultsHeaderProps {
  searchQuery: SearchQuery;
  onBack: () => void;
}

const calculateCheckoutDate = (checkIn: string, nights: number): string => {
    const checkInDate = new Date(checkIn);
    checkInDate.setDate(checkInDate.getDate() + nights);
    const day = String(checkInDate.getDate()).padStart(2, '0');
    const month = String(checkInDate.getMonth() + 1).padStart(2, '0');
    const year = checkInDate.getFullYear();
    return `${day}.${month}.${year}`;
};

const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}

export const ResultsHeader: React.FC<ResultsHeaderProps> = ({ searchQuery, onBack }) => {
    const { t } = useLocalization();

    const { destinationName, departureName, checkIn, nights, adults } = searchQuery;
    const checkoutDate = calculateCheckoutDate(checkIn, nights);
    const formattedCheckin = formatDate(checkIn);

    const summaryText = `${departureName} - ${destinationName?.toUpperCase()}, Check In ${formattedCheckin}, Check Out ${checkoutDate}, ${nights} Nights, ${adults} Adult`;

    return (
        <div className="flex justify-between items-center">
            <div>
                <h1 className="text-2xl font-bold text-gray-800">{destinationName?.toUpperCase()} Hotels</h1>
                <p className="text-sm text-gray-500 mt-1">{summaryText}</p>
            </div>
            <button 
                onClick={onBack}
                className="bg-amber-500 text-white font-bold py-2.5 px-6 rounded-md hover:bg-amber-600 transition-colors duration-300"
            >
                {t('search_again')}
            </button>
        </div>
    );
};
